const multiplyMixBlendMode: { mixBlendMode: 'multiply' } = {
	mixBlendMode: 'multiply',
};

export const Sasquatch = ({ title }: { title: string }) => (
	<svg width="100%" viewBox="0 0 503 503" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
		<title>{title}</title>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M355.241 449.264C420.138 412.892 464 343.45 464 263.764C464 146.404 368.861 51.2642 251.5 51.2642C134.139 51.2642 39 146.404 39 263.764C39 343.45 82.8615 412.892 147.759 449.264H355.241Z"
			fill="#C2F4D7"
		/>
		<g style={multiplyMixBlendMode}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M279.321 136.639L258.725 272.402L275.641 266.805L256.752 285.406L252.229 315.22H316.234L316.185 315.531H408L399.605 270.593L385.742 259.124L398.008 262.047L377.089 150.073L367.657 142.27L376.003 144.259L370.729 116.028L362.093 108.883L369.734 110.704L358.101 48.4338L345.368 129.571L350.964 127.728L344.692 133.876L331.161 220.101L324.239 181.776L312.606 171.825L322.9 174.361L305.394 77.4291L296.588 69.8961L304.38 71.8157L296.106 26L282.078 118.466L287.963 116.461L281.368 123.147L280.517 128.756L290.427 125.38L279.321 136.639ZM331.343 221.108L332.556 227.823L322.464 225.337L329.64 231.475L344.703 216.707L331.343 221.108ZM333.962 235.611L334.196 236.903L336.357 234.845L333.962 235.611ZM157.266 236.214L149.264 287.317L156.598 284.971L148.411 292.768L144.813 315.742H237.781L230.527 276.825L218.14 266.578L229.103 269.19L213.807 187.131L195.88 172.301L211.747 176.081L210.144 167.481L201.785 160.566L209.183 162.329L187.255 44.6948L169.479 158.221L176.239 155.994L168.665 163.42L158.883 225.888L172.311 221.464L157.266 236.214Z"
				fill="#16AC52"
			/>
		</g>
		<path
			d="M282.076 208.704C284.487 201.772 287.305 194.151 289.914 187.28C293.783 177.086 288.896 165.586 278.792 161.488C267.939 157.086 255.709 163.085 250.787 173.713C246.468 183.039 240.936 192.151 234.957 195.91C221.393 204.44 208.542 208.704 194.263 230.738C179.985 252.772 159.281 265.566 150 259.169C151.428 267.461 157.568 283.619 170.704 281.913C183.84 280.208 202.831 268.409 210.684 262.723C207.114 267.224 200.689 279.355 203.544 291.864C207.114 307.501 221.393 330.956 208.542 346.593C195.691 362.23 193.549 366.495 208.542 384.264C208.542 378.578 217.109 376.446 227.818 374.313C237.914 372.303 247.094 360.098 248.522 323.849C261.372 326.692 270.653 349.436 277.079 366.495C283.504 383.553 292.071 378.578 307.064 378.578V360.098C306.35 322.427 286.36 308.212 275.651 297.55C267.084 289.021 268.75 266.987 270.653 257.036C272.081 260.353 277.65 267.698 288.502 270.541C302.066 274.095 325.626 275.516 330.623 284.046C335.621 276.938 341.618 261.585 325.626 257.036C305.636 251.35 275.651 227.184 282.076 208.704Z"
			fill="#A26A47"
			fillOpacity="0.9"
		/>
		<g style={{ mixBlendMode: 'multiply' }}>
			<rect x="265.088" y="180.422" width="4.55234" height="5.69043" rx="2.27617" transform="rotate(24.9837 265.088 180.422)" fill="#3B4044" />
		</g>
		<g style={multiplyMixBlendMode}>
			<rect x="282.14" y="186.106" width="4.55234" height="5.69043" rx="2.27617" transform="rotate(24.9837 282.14 186.106)" fill="#3B4044" />
		</g>
		<g style={multiplyMixBlendMode}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M207.245 254.084L183.492 405.507L203 399.264L181.216 420.01L176 453.264H286.842L270.153 363.894L257 353.013L268.639 355.786L259.048 304.428L245.632 293.329L257.503 296.157L237.314 188.047L227.158 179.645L236.145 181.786L226.602 130.685L210.424 233.815L217.211 231.58L209.605 239.036L208.624 245.292L220.053 241.527L207.245 254.084Z"
				fill="#92E7B4"
			/>
		</g>
		<g style={multiplyMixBlendMode}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M71.5673 305.85L62.883 361.311L70.8422 358.764L61.9568 367.226L58.0527 392.159H158.947L151.074 349.924L137.632 338.803L149.53 341.638L132.929 252.582L113.474 236.487L130.693 240.59L128.954 231.258L119.882 223.752L127.911 225.665L104.113 98.001L84.8211 221.207L92.158 218.79L83.9376 226.85L73.3222 294.643L87.8948 289.843L71.5673 305.85Z"
				fill="#92E7B4"
			/>
		</g>
		<g style={multiplyMixBlendMode}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M371.557 324.079L370.585 330.275L379.342 327.473L369.563 336.787L357 416.842H458.696L449.397 367.069L434.042 354.366L447.629 357.603L424.458 233.578L414.011 224.935L423.255 227.137L417.413 195.868L407.848 187.955L416.312 189.971L403.426 121L389.323 210.87L395.521 208.828L388.575 215.638L373.392 312.388L388.587 307.383L371.557 324.079Z"
				fill="#92E7B4"
			/>
		</g>
	</svg>
);
